import { UI_PRIMITIVE__checkbox } from '@/components/ui/UI_PRIMITIVE__checkbox';
import { use_dispatch } from '@/hooks/_base/use_dispatch';
import { use_slice_workspace } from '@/hooks/store/use_slices';
import { remote_workspace_update } from '@/state/workspace/entity/remote_workspace_update';
import { useState } from 'react';

export const WSTableUserCreditLimitCheckboxTemplate = () => {
  const dispatch = use_dispatch();

  const { workspace_current } = use_slice_workspace(['workspace_current']);

  const [isLoading, setIsLoading] = useState(false);

  async function onCheckedChange() {
    let workspace_new = workspace_current.clone({
      credit_limit_for_new_workspace_users_enabled: !workspace_current.credit_limit_for_new_workspace_users_enabled,
    });

    setIsLoading(true);
    await dispatch(remote_workspace_update(workspace_new));
    setIsLoading(false);
  }

  return (
    <UI_PRIMITIVE__checkbox
      id={'credit-limit-template-checkbox'}
      disabled={isLoading}
      checked={workspace_current.credit_limit_for_new_workspace_users_enabled}
      {...{ onCheckedChange }}
    />
  );
};
